<template>
	<div class="node-container" style="display: flex;flex-wrap: nowrap;width: 100%;">
		<div
			style="border: 1px #419FFF solid;width: 4px;height: 38px;background-color: #419FFF;border-radius: 10px 0 0 10px;">
		</div>
		<div style="border: 1px #d1d1d1 solid;flex:1;height: 38px;background-color: white;" size="mini"
			:style="{ backgroundColor: currentNodeId === item.id ? '#D9ECFF' : '' }" @click="add(e)">
		
			<span
			
				style="display: flex;justify-content: center;align-items: center;padding-top: 10px;">{{ item.procedureDesc }}</span>
		</div>
	</div>
</template>

<script>
	export default {
		name: "web_components_craft_node2",
		inject: ["getGraph", "getNode"],
		data() {
			return {
				radio1: '',
				priority: null,
				item: {},
				index: null,
				currentNodeId: null,
				// t:null,
				miStatusColor(val) {
					if (val == 'selectIndex') {
						return '#409eff'
					} else {
						return '#FEF0F0'
					}
				},
			};
		},
		mounted() {
			const self2 = this;
			const node2 = this.getNode();
			//监听数据改变事件
			node2.on("change:data", ({
				current
			}) => {
				self2.priority = current.priority;
				self2.item = current.item
				self2.currentNodeId = current.currentNodeId
				// console.log('qqqqqq1',self2.currentNodeId)
			});

			//初次进入的时候赋值外面传入的数据
			this.priority = node2.getData().priority;
			this.item = node2.getData().item;
			this.currentNodeId = node2.getData().currentNodeId;


      // pid = {
			// 	"5":2,
			// 	"3":1,
			// 	"2":6
			// }
			// for (var i = 0; i < node.length; i++) {
			// 	if(pid[node[i].parentId]){
			// 		pid[node[i].parentId]++
			// 	}else{
			// 		pid[node[i].parentId] = 0
			// 	}
			// }
			// width:133x6
			

		},
		methods: {
			add(e) {
        console.log(e)
				this.utils.event_hub.$emit('node2Tap', {
					item: this.item,

				});
				// node.setData({
				//   num: num + 1,
				// });
			},
		},
	};
</script>
